<template>
  <div class="row">
    <div class="col-xl-8 col-lg-12">
      <div class="card card-default">
        <form-wizard
          title=""
          subtitle=""
          @on-complete="onComplete"
          stepSize="sm"
        >
          <tab-content
            title="Link Details"
            :before-change="() => validateStep('layer2link')"
          >
            <form novalidate data-vv-scope="layer2link">
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    v-if="filledInSaleDefinition.requiredObjs.layer2link"
                    :class="{ 'has-error': errors.has('layer2link.Package') }"
                  >
                    <label class="control-label">Package *</label>
                    <div class="input-group">
                      <v-select
                        name="Package"
                        placeholder="Select Package"
                        v-validate="'required'"
                        label="description"
                        valueProp="layer2LinkPackageNumber"
                        v-model="
                          filledInSaleDefinition.requiredObjs.layer2link
                            .layer2LinkPackageNumber
                        "
                        :options="
                          filledInSaleDefinition.selectableOptions
                            .layer2linkPackage
                        "
                      ></v-select>
                    </div>
                    <span
                      class="has-error"
                      v-if="errors.has('layer2link.Package')"
                      >{{ errors.first("layer2link.Package") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{ 'has-error': errors.has('layer2link.Name') }"
                  >
                    <label class="control-label">Name *</label>
                    <input
                      class="form-control"
                      v-model="
                        filledInSaleDefinition.requiredObjs.layer2link.name
                      "
                      name="Name"
                      v-validate="'required'"
                    />
                    <span
                      class="has-error"
                      v-if="errors.has('layer2link.Name')"
                      >{{ errors.first("layer2link.Name") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{ 'has-error': errors.has('layer2link.Vlan Name') }"
                  >
                    <label class="control-label">Vlan Name *</label>
                    <input
                      class="form-control"
                      v-model="
                        filledInSaleDefinition.requiredObjs.layer2link.vlanName
                      "
                      name="Vlan Name"
                      v-validate="'required'"
                    />
                    <span
                      class="has-error"
                      v-if="errors.has('layer2link.Vlan Name')"
                      >{{ errors.first("layer2link.Vlan Name") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-8 col-lg-12">
                  <div
                    class="form-group"
                    :class="{
                      'has-error': errors.has('layer2link.Vlan Number'),
                    }"
                  >
                    <label class="control-label">Vlan Number *</label>
                    <input
                      class="form-control"
                      v-model="
                        filledInSaleDefinition.requiredObjs.layer2link
                          .vlanNumber
                      "
                      name="Vlan Number"
                      v-validate="'required'"
                    />
                    <span
                      class="has-error"
                      v-if="errors.has('layer2link.Vlan Number')"
                      >{{ errors.first("layer2link.Vlan Number") }}</span
                    >
                  </div>
                </div>
              </div>
            </form>
          </tab-content>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: {
    FormWizard,
    TabContent,
  },
  props: {
    emptySaleDefinition: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filledInSaleDefinition: {
        requiredObjs: {
          layer2link: {},
        },
        selectableOptions: {
          layer2linkPackage: [],
        },
      },
    };
  },
  mounted: function () {
    this.filledInSaleDefinition = this.emptySaleDefinition;
  },
  methods: {
    validateStep: function (stepName) {
      return this.$validator.validateAll(stepName).then((result) => {
        if (result) {
          return true;
        } else {
          return false;
        }
      });
    },
    onComplete: function () {
      this.$emit("createSale", this.filledInSaleDefinition);
    },
  },
};
</script>

<style>
</style>